import { Box } from "@mui/material";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { LoadingButton } from "../../components/LoadingButton";

interface PlaceBidButtonProps {
  shiftId: string;
  disabled?: boolean;
  isLoading?: boolean;
  onDisabledButtonClick?: () => void;
  onPlaceBidButtonClick?: (shiftId: string) => void;
  fullWidth?: boolean;
  placedBidAmountInMinorUnits?: number;
}

export function PlaceBidButton(props: PlaceBidButtonProps) {
  const {
    shiftId,
    disabled,
    isLoading = false,
    onDisabledButtonClick,
    onPlaceBidButtonClick,
    fullWidth = false,
    placedBidAmountInMinorUnits,
  } = props;
  const buttonContent = (
    <LoadingButton
      size="large"
      variant="contained"
      disabled={disabled}
      isLoading={isLoading}
      fullWidth={fullWidth}
      sx={{
        minWidth: "30%",
        background: "primary",
      }}
      onClick={() => {
        onPlaceBidButtonClick?.(shiftId);
      }}
    >
      {disabled &&
        (placedBidAmountInMinorUnits
          ? `Bid placed at ${formatCentsAsUsd(placedBidAmountInMinorUnits)}/hr`
          : "Cannot place bid")}
      {!disabled && "Place a bid"}
    </LoadingButton>
  );

  // When disabled, wrap in a clickable container to capture clicks
  if (disabled) {
    return <Box onClick={onDisabledButtonClick}>{buttonContent}</Box>;
  }

  // When enabled, return the button directly
  return buttonContent;
}
